// LLM generated - Model gpt-5.2-codex
import { Fragment, useContext } from 'react';
import { match } from 'ts-pattern';

import useAnimatedDialogModals from '~/domains/common/context/useAnimatedDialogModals';
import DialogContainer from '~/domains/design-system/components/Dialog/DialogContainer';

import { ConnectedPromotionBonusModal } from '../domains/promoCodes/components/PromotionBonusModal/ConnectedPromotionBonusModal';
import { PromotionBonusModal } from '../domains/promoCodes/components/PromotionBonusModal/PromotionBonusModal';
import WhalersClubDetailModal from '../domains/gamification/domains/whalersClub/components/WhalersClubDetailModal/WhalersClubDetailModal';
import ConnectedWhalersClubRewardHistoryModal from '../domains/gamification/domains/whalersClub/components/ConnectedWhalersClubRewardHistoryModal/ConnectedWhalersClubRewardHistoryModal';
import MissionStartedModal from '../domains/gamification/domains/missions/components/MissionStartedModal/MissionStartedModal';
import ConnectedMissionCompletedModal from '../domains/gamification/domains/missions/components/MissionCompletedModal/ConnectedMissionCompletedModal';
import ConnectedPromoTermsModal from '../components/PromoTermsModal/ConnectedPromoTermsModal';

import { SplitEntryPromoModal } from './contestPromoModals/SplitEntryPromoModal';
import { MarketplacePromoModal } from './contestPromoModals/MarketplacePromoModal';
import { PromotionsModalsContext } from './PromotionsModalsContext';

function PromotionsModals() {
  const { modals, closeModal, isCloseDisabled } = useContext(PromotionsModalsContext);
  const { modalsCache, activeModal, closingModal } = useAnimatedDialogModals({
    modals,
  });

  return (
    <DialogContainer
      isOpen={!!modals.length}
      onClose={isCloseDisabled ? undefined : closeModal}
      lockScroll
    >
      {modalsCache.map((modal) => {
        const commonProps = {
          onClose: closeModal,
          isCloseDisabled,
          isOpen: activeModal === modal,
          isClosing: closingModal === modal,
        };

        return (
          <Fragment key={modal.type}>
            {match(modal)
              .returnType<React.ReactNode>()
              .with({ type: 'PromoBonusModal' }, (rest) => (
                <PromotionBonusModal {...rest} {...commonProps} />
              ))
              .with({ type: 'PromoBonusModalWithRedeem' }, (rest) => (
                <ConnectedPromotionBonusModal {...rest} {...commonProps} />
              ))
              .with({ type: 'WhalersClubDetailModal' }, (rest) => (
                <WhalersClubDetailModal {...rest} {...commonProps} />
              ))
              .with({ type: 'ConnectedWhalersClubRewardHistoryModal' }, (rest) => (
                <ConnectedWhalersClubRewardHistoryModal {...rest} {...commonProps} />
              ))
              .with({ type: 'PromoTermsModal' }, (rest) => (
                <ConnectedPromoTermsModal {...rest} {...commonProps} />
              ))
              .with({ type: 'MissionStartedModal' }, (rest) => (
                <MissionStartedModal {...rest} {...commonProps} />
              ))
              .with({ type: 'MissionCompletedModal' }, (rest) => (
                <ConnectedMissionCompletedModal {...rest} {...commonProps} />
              ))
              .with({ type: 'ContestSplitEntryPromoModal' }, (rest) => (
                <SplitEntryPromoModal {...rest} {...commonProps} />
              ))
              .with({ type: 'ContestMarketplacePromoModal' }, (rest) => (
                <MarketplacePromoModal {...rest} {...commonProps} />
              ))
              .otherwise(() => null)}
          </Fragment>
        );
      })}
    </DialogContainer>
  );
}

export default PromotionsModals;
